<template>
    <span :class="classes">
        <i
            v-if="icon"
            :class="[icon, iconClass]"
            class="tw:inline-block tw:translate-y-[0.03em]"
            aria-hidden="true"
        ></i>
        <slot>{{ label }}</slot>
    </span>
</template>

<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        label: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        },
        /** Clases extra para el icono (p. ej. color semántico). */
        iconClass: {
            type: String,
            default: ''
        },
        /** amber | emerald | slate | blue | cyan | red | violet */
        variant: {
            type: String,
            default: 'slate'
        },
        /** sm = 11px (chips de ficha) · md = 12px (pills de panel) */
        size: {
            type: String,
            default: 'md'
        },
        /** bold = énfasis (defecto) · semibold · medium */
        weight: {
            type: String,
            default: 'bold'
        },
        /** false = sin borde (chips de contador) */
        bordered: {
            type: Boolean,
            default: true
        },
        /** full = cápsula · md = esquina suave */
        rounded: {
            type: String,
            default: 'full'
        },
        customClass: {
            type: String,
            default: ''
        }
    });

    const VARIANTS = {
        amber: 'tw:border-amber-300 tw:bg-amber-100 tw:text-amber-800',
        emerald: 'tw:border-emerald-300 tw:bg-emerald-100 tw:text-emerald-800',
        slate: 'tw:border-slate-200 tw:bg-slate-100 tw:text-slate-700',
        blue: 'tw:border-blue-200 tw:bg-blue-50 tw:text-blue-700',
        cyan: 'tw:border-cyan-200 tw:bg-cyan-50 tw:text-cyan-800',
        red: 'tw:border-red-200 tw:bg-red-50 tw:text-red-700',
        violet: 'tw:border-violet-300 tw:bg-violet-100 tw:text-violet-800'
    };

    const SIZES = {
        sm: 'tw:px-2 tw:py-0.5 tw:text-[11px]',
        md: 'tw:px-3 tw:py-1 tw:text-xs'
    };

    const WEIGHTS = {
        bold: 'tw:font-bold',
        semibold: 'tw:font-semibold',
        medium: 'tw:font-medium'
    };

    const RADII = {
        full: 'tw:rounded-full',
        md: 'tw:rounded-md'
    };

    const classes = computed(() => [
        'tw:inline-flex tw:shrink-0 tw:items-center tw:gap-1.5',
        props.bordered ? 'tw:border' : 'tw:border-0',
        WEIGHTS[props.weight] ?? WEIGHTS.bold,
        VARIANTS[props.variant] ?? VARIANTS.slate,
        SIZES[props.size] ?? SIZES.md,
        RADII[props.rounded] ?? RADII.full,
        props.customClass
    ].filter(Boolean).join(' '));
</script>
